module.exports = __webpack_public_path__ + "img/gift1.62ab557a.png";